// extracted by mini-css-extract-plugin
export var author = "style-module--author--ae9d4";
export var day1Brain = "style-module--day1-brain--035c3";
export var day1Globe = "style-module--day1-globe--42203";
export var day1Hyerog = "style-module--day1-hyerog--681c8";
export var day25neuro = "style-module--day2-5neuro--a803d";
export var day2Alghorytm = "style-module--day2-alghorytm--23543";
export var day2Mindmap = "style-module--day2-mindmap--cd3c3";
export var day3Read = "style-module--day3-read--48070";
export var day3Readspeed = "style-module--day3-readspeed--a29c5";
export var day3Sledi = "style-module--day3-sledi--eda2f";
export var day4Metod = "style-module--day4-metod--2c060";
export var day4Navik = "style-module--day4-navik--b9cc0";
export var day4Travel = "style-module--day4-travel--b0c4a";
export var day5Alghorytm = "style-module--day5-alghorytm--fbcce";
export var day5Koordinat = "style-module--day5-koordinat--6b99e";
export var day5Planning = "style-module--day5-planning--f9a8f";
export var extra = "style-module--extra--63fe1";
export var filesList = "style-module--files-list--07c22";
export var filesWrap = "style-module--files-wrap--35e84";
export var gallery = "style-module--gallery--4b2a7";
export var head = "style-module--head--b4f81";
export var infoWrap = "style-module--info-wrap--4aa52";
export var mainList = "style-module--main-list--b510c";
export var program = "style-module--program--330fe";
export var resultWrap = "style-module--result-wrap--dd3b9";
export var screenBtn = "style-module--screen-btn--936c7";
export var slides = "style-module--slides--903d5";
export var slidesList = "style-module--slides-list--62f1e";
export var themes = "style-module--themes--67480";
export var themesList = "style-module--themes-list--d80e2";
export var time = "style-module--time--55aac";